import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-receipt-modal',
  templateUrl: './receipt-modal.component.html',
  styleUrls: ['./receipt-modal.component.css']
})
export class ReceiptModalComponent implements OnInit {

  closeEvents: Subject<void> = new Subject<void>();

  constructor(public _modal: ModalService) { }

  ngOnInit(): void {
  }

  hide() {
    this.closeEvents.next();
    this._modal.hide();
  }

}
